import "./CountertopUniversityCourseCard.scss";
import { useNavigate } from "react-router-dom";
import { CountertopUniversityDetail } from "../types/CountertopUniversityDetail";
import { Button } from "devextreme-react";

export default function CountertopUniversityCourseCard({ item } : { item: CountertopUniversityDetail}) {
    const navigate = useNavigate();

    const handleNavigate = () => {
        navigate(`/countertop-university/${item.countertopUniversityID}`);
    };

    return (
        <div className="countertop-university-course-card">
            <div className="countertop-university-course-card-div-img">
                {item.imageUrl ? (
                    <img 
                        className="countertop-university-course-card-img"
                        src={item.imageUrl} 
                        alt={item.title}
                    />
                ) : (
                    <span className="countertop-university-course-card-span-img">No Image</span>
                )}
            </div>

            <div className="countertop-university-course-card-content">
                <div>
                    <h1 className="countertop-university-course-card-h1">
                        {item.title}
                    </h1>
                    <p className="countertop-university-course-card-description">
                        {item.description || 'No description available'}
                    </p>
                </div>

                <Button
                    className="countertop-university-course-card-button"
                    text="Begin Course"
                    onClick={handleNavigate}
                    type="default"
                />
            </div>
        </div>
    )
}